import common from "@/services/common";

const state = () => ({
  ip: {},
  region: "",
  sessionWOTrialData: [],
  userStatus: [],
  reportData: [],
  revenueData: [],
  loader: false,
  userState: {}, // setting data from nba.js
  todayLineup: {},
  verifyStatus: {},
  loginHistory: {},
  build_exposure: [],
  bestBet: {},
  bestBetProp: {},
  articles: [],
  team_news: [],
  fullStats: [],
  playerLoader: false,
  player_score: {},
  season_stat: [],
  player_news: [],
});

const mutations = {
  SET_IP(state, data) {
    state.ip = data;
  },

  SET_REGION(state, data) {
    state.region = data;
  },

  SET_SESSION_WO_Trial(state, data) {
    state.sessionWOTrialData = data;
  },

  SET_USER_STATUS(state, data) {
    state.userStatus = data;
    // console.log('data', state.userStatus);
  },

  SET_REPORT_DATA(state, data) {
    state.reportData = data;
    console.log("report Data", data);
  },

  SET_REVENUE_DATA(state, data) {
    state.revenueData = data;
  },

  SET_REVENUE_LOADER(state, data) {
    state.loader = data;
  },

  SET_TODAY_LINEUP_STATUS(state, data) {
    state.todayLineup = data;
  },

  SET_LOADER(state, data) {
    state.loader = data;
  },

  SET_VERIFY_STATUS(state, data) {
    state.verifyStatus = data;
    console.log("verify", data);
  },

  SET_LOGIN_HISTORY(state, data) {
    state.loginHistory = data;
  },

  SET_BEST_BET(state, data) {
    state.bestBet = data;
  },

  SET_BEST_BET_PROPS(state, data) {
    state.bestBetProp = data;
  },

  SET_ARTICLES(state, data) {
    state.articles = data;
  },

  APPEND_ARTICLES(state, data) {
    state.articles = state.articles.concat(data);
  },

  SET_BUILD_EXPOSURE(state, data) {
    state.build_exposure = data;
  },

  SET_TEAM_NEWS(state, data) {
    state.team_news = data;
  },

  SET_FULL_STAT(state, data) {
    state.fullStats = data;
  },

  SET_PLAYERDETAIL_LOADER(state, data) {
    state.playerLoader = data;
  },

  SET_PLAYER_SCORE(state, data) {
    state.player_score = data;
  },

  SET_SEASON_STATS(state, data) {
    state.season_stat = data;
  },

  SET_PLAYER_NEWS(state, data) {
    state.player_news = data;
  },
};

const actions = {
  async getUserIp({ commit }) {
    try {
      const res = await common.getIp();
      commit("SET_IP", res.data);
    } catch (err) {
      return console.error("err in geting IP: ", err);
    }
  },

  getUserRegion({ commit }, payload) {
    common
      .getRegion(payload)
      .then((res) => {
        commit("SET_REGION", res.data);
      })
      .catch((err) => console.error("err in geting region: ", err));
  },

  async createSeesionWithoutTrial({ commit }, payload) {
    try {
      const res = await common.createSessionwithoutTrial(payload);
      commit("SET_SESSION_WO_Trial", res.data);
    } catch (err) {
      return console.error("err in createSeesionWithoutTrial:", err);
    }
  },

  async getUserStatus({ commit, dispatch }, payload) {
    try {
      const res = await common.getUserStatus(payload);
      if (res.data.success) {
        const notification_1 = {
          type: "info",
          message: `Your Subscription is '${res.data.data.status}'`,
        };
        dispatch("notification/add", notification_1, { root: true });
        commit("SET_USER_STATUS", res.data);
      }
    } catch (err) {
      console.error("err in getUserStatus: ", err);
    }
  },

  async getReportData({ commit }) {
    try {
      const res = await common.getReport();
      commit("SET_REPORT_DATA", res.data);
    } catch (err) {
      console.error(err);
    }
  },

  async getRevenue({ commit, dispatch }, payload) {
    try {
      commit("SET_REVENUE_LOADER", true);
      const res = await common.getRevenueData(payload);
      commit("SET_REVENUE_DATA", res.data);
      commit("SET_REVENUE_LOADER", false);
      const notification = {
        type: "success",
        message: "Loaded successfully",
      };
      dispatch("notification/add", notification, { root: true });
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with Revenue data: " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  submitCsvProjection({ dispatch }, payload) {
    common
      .SubmitCsvProjection(payload)
      .then((res) => {
        if (res.data.success) {
          const notification = {
            type: "success",
            message: "Loaded successfully",
          };
          dispatch("notification/add", notification, { root: true });
        } else {
          const notification_1 = {
            type: "error",
            message: "Unable to upload, try again.",
          };
          dispatch("notification/add", notification_1, { root: true });
        }
      })
      .catch((err) => {
        const notification = {
          type: "error",
          message: "There was an error with csv Import: " + err.message,
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  async checkTodayLineup({ commit, dispatch }, payload) {
    try {
      commit("SET_LOADER", true);
      const response = await common.checkTodayLineup(payload);
      commit("SET_TODAY_LINEUP_STATUS", response.data);
      commit("SET_LOADER", true);
    } catch (error) {
      const notification = {
        type: "error",
        message: "There was an error with Today build: " + err.message,
      };
      dispatch("notification/add", notification, { root: true });
    }
  },

  async sendVerifyEmail({ commit, dispatch }, payload) {
    try {
      const response = await common.sendVerifyEmail(payload);
      if (response.data.success) {
        const notification = {
          type: "success",
          message: "A mail has been sent to email Id, Please verify.",
        };
        dispatch("notification/add", notification, { root: true });
      }
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "Something went wrong try again !",
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async verifyEmail({ commit, dispatch }, payload) {
    try {
      const response = await common.verifyEmail(payload);
      if (response.data.success) {
        const notification = {
          type: "success",
          message: "Verification Success !.",
        };
        dispatch("notification/add", notification, { root: true });
      }
      commit("SET_VERIFY_STATUS", response.data);
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "Something went wrong try again !",
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async getUserLoginReport({ commit, dispatch }, payload) {
    try {
      commit("SET_LOADER", true);
      const response = await common.userLoginData(payload);
      if (response.data.success) {
        const notification = {
          type: "success",
          message: "Login History Loaded !",
        };
        dispatch("notification/add", notification, { root: true });
      }
      commit("SET_LOGIN_HISTORY", response.data);
      commit("SET_LOADER", false);
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "Something went wrong try again !",
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async saveBestBet({ dispatch }, payload) {
    try {
      const response = await common.saveUserBestBet(payload);
      if (response.data.success) {
        const notification = {
          type: "success",
          message: "Best Bet saved succesfully !",
        };
        dispatch("notification/add", notification, { root: true });
      }
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "Something went wrong try again !",
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async saveBestBetProps({ dispatch }, payload) {
    try {
      const response = await common.saveUserBestBetProps(payload);
      if (response.data.success) {
        const notification = {
          type: "success",
          message: "Best Bet saved succesfully !",
        };
        dispatch("notification/add", notification, { root: true });
      }
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "Something went wrong try again !",
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async getBestBet({ commit, dispatch },payload) {
    try {
      const response = await common.getBestBet(payload);
      if (response.data.success) {
        const notification = {
          type: "success",
          message: "Best Bet Loaded !",
        };
        dispatch("notification/add", notification, { root: true });
        commit("SET_BEST_BET", response.data);
      }
      return response.data || {};
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "Something went wrong try again !",
      };
      dispatch("notification/add", notification_1, { root: true });
      return {};
    }
  },

  async getBestBetProps({ commit, dispatch },payload) {
    try {
      const response = await common.getBestBetProps(payload);
      if (response.data.success) {
        const notification = {
          type: "success",
          message: "Best Bet Loaded !",
        };
        dispatch("notification/add", notification, { root: true });
        commit("SET_BEST_BET_PROPS", response.data);
      }
      return response.data || {};
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "Something went wrong try again !",
      };
      dispatch("notification/add", notification_1, { root: true });
      return {};
    }
  },

  async createArticle({ dispatch }, payload) {
    try {
      const response = await common.createArticle(payload);
      if (response.data.success) {
        const notification = {
          type: "success",
          message: "Article posted !",
        };
        dispatch("notification/add", notification, { root: true });
      }
      return response.data;
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "Something went wrong try again !",
      };
      dispatch("notification/add", notification_1, { root: true });
      return null;
    }
  },

  async updateArticle({ dispatch }, payload) {
    try {
      const response = await common.updateArticle(payload);
      if (response.data.success) {
        const notification = {
          type: "success",
          message: "Article updated !",
        };
        dispatch("notification/add", notification, { root: true });
      }
      return response.data;
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "Something went wrong try again !",
      };
      dispatch("notification/add", notification_1, { root: true });
      return null;
    }
  },

  async getArticles({ commit, dispatch }, payload) {
    try {
      const response = await common.getArticles(payload);
      if (response.data.success) {
        const docs = response.data.data || [];
        if (payload.page > 1) {
          commit("APPEND_ARTICLES", docs);
        } else {
          commit("SET_ARTICLES", docs);
        }
        return response.data;
      }
      return null;
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "Something went wrong try again !",
      };
      dispatch("notification/add", notification_1, { root: true });
      return null;
    }
  },

  async deleteArticle({ dispatch }, payload) {
    try {
      const response = await common.deleteArticle(payload);
      if (response.data.success) {
        const notification = {
          type: "success",
          message: "Article deleted !",
        };
        dispatch("notification/add", notification, { root: true });
      }
      return response.data;
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "Something went wrong try again !",
      };
      dispatch("notification/add", notification_1, { root: true });
      return null;
    }
  },

  async setBuildExposure({ commit, dispatch }, payload) {
    commit("SET_LOADER", true);
    try {
      const res = await common.setBuildExposure(payload);
      commit("SET_BUILD_EXPOSURE", res.data);
      if (res.data.success) {
        const notification = {
          type: "success",
          message: "Exposure loaded successfully.",
        };
        dispatch("notification/add", notification, { root: true });
      }
      commit("SET_LOADER", false);
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "There was an error with build exposure : " + error.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async fetchTeamNews({ commit, dispatch }, payload) {
    try {
      const res = await common.getTeamNews(payload);
      commit("SET_TEAM_NEWS", res.data);
      if (res.data.success) {
        const notification = {
          type: "success",
          message: "Exposure loaded successfully.",
        };
        dispatch("notification/add", notification, { root: true });
      }
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "There was an error with loading news : " + error.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async GetPlayerFullStats({ commit, dispatch }, payload) {
    commit("SET_PLAYERDETAIL_LOADER", true);
    try {
      const res = await common.getPlayerFullStats(payload);
      commit("SET_FULL_STAT", res.data);
      commit("SET_PLAYERDETAIL_LOADER", false);
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with fetching full stats: " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async GetPlayerScore({ commit, dispatch }, payload) {
    try {
      const res = await common.getPlayerScore(payload);
      commit("SET_PLAYER_SCORE", res.data);
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with player score: " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async GetPlayerSeasonStats({ commit, dispatch }, payload) {
    try {
      const res = await common.getPlayerSeasonStats(payload);
      commit("SET_SEASON_STATS", res.data);
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with season stats: " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async GetPlayerNews({ commit, dispatch }, payload) {
    try {
      const res = await common.getPlayerNews(payload);
      commit("SET_PLAYER_NEWS", res.data);
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with News: " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async createFreeSubscription({ commit, dispatch }, payload) {
    try {
      const res = await common.createFreeSub(payload);
      if (res.data.success) {
        const notification = {
          type: "success",
          message: "created free user successfully.",
        };
        dispatch("notification/add", notification, { root: true });
      }
    } catch (error) {
      const notification_1 = {
        type: "error",
        message: "There was an error while creating free user " + error.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
